import { Property } from "@/features/survey/types";
import { useGetPropertyImageQuery } from "@/services/mediaService";
import useTransformedImageUrl from "@/shared/hooks/useTransformedImage";
import placeholderImage from "/image-placeholder-medium.png";

/**
 * Custom hook to get resolved property image URL
 * Uses the same logic as PropertyCard component
 */
export const usePropertyImage = (property: Property) => {
  // Fetch property image from API
  const { data: propertyImage, isLoading: isImageLoading } =
    useGetPropertyImageQuery(property.id, {
      skip: !property.id,
    });

  // Determine image source with fallback (same logic as PropertyCard)
  const imageSrc = !propertyImage?.cloudfrontUrl
    ? placeholderImage
    : propertyImage.cloudfrontUrl;

  // Transform image URL using the transformation hook
  const { transformedImageUrl, isLoading: isTransformLoading } =
    useTransformedImageUrl(
      imageSrc !== placeholderImage ? imageSrc : undefined,
    );

  const isLoading = isImageLoading || isTransformLoading;

  return {
    imageSrc: transformedImageUrl || imageSrc,
    isLoading,
  };
};
